module.exports = __webpack_public_path__ + "img/error.8f9063fa.png";